import React, { useEffect, useState } from "react";
import { Edit as EditIcon } from "@mui/icons-material";
import {
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ModalAvaliacao } from "./ModalAvaliação";
import {
  Container,
  HelperDiv,
  HelperDivNaoTributado,
  Label,
  Section,
  Th,
  TitleConclusao,
  Value,
} from "./styles";
import theme from "../../../Styles/theme";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";

interface Props {
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
  editavel: boolean;
  handleModal: React.Dispatch<React.SetStateAction<boolean>>;
}




export function AvaliaçãoContainer({
  imovel,
  handleSetImovel,
  editavel,
  handleModal
}: Props) {
  const [openModalAvaliacao, setOpenModalAvaliacao] = useState(false);

  const [aliquota, setAliquota] = useState(2);
  const [aliquota2, setAliquota2] = useState(2);
  const [totalDeclaradoMenosEntrada, setTotalDeclaradoMenosEntrada] = useState(0);
  const [entrada, setEntrada] = useState(0);
  const [restanteAvaliacao, setRestanteAvaliacao] = useState(0);

  useEffect(() => {
    handleModal(!openModalAvaliacao);
  }, [openModalAvaliacao]);

  useEffect(() => {
    const terreonoValorTotal = imovel.VALOR_CARTORIO_TERRENO
      ? imovel.VALOR_CARTORIO_TERRENO
      : 0;
    const benfeitoriasValoTotal = imovel.VALOR_CARTORIO_BENFEITORIAS
      ? imovel.VALOR_CARTORIO_BENFEITORIAS
      : 0;
    setTotalDeclaradoMenosEntrada((terreonoValorTotal + benfeitoriasValoTotal) - (imovel.ENTRADA ? imovel.ENTRADA : 0));

    setEntrada(imovel.ENTRADA);

    setRestanteAvaliacao(((imovel.VALOR_PREFEITURA_TERRENO
      ? imovel.VALOR_PREFEITURA_TERRENO
      : 0) + (imovel.VALOR_PREFEITURA_BENFEITORIAS
        ? imovel.VALOR_PREFEITURA_BENFEITORIAS
        : 0)) - (terreonoValorTotal + benfeitoriasValoTotal))


    if (imovel.ALIQUOTA) {
      setAliquota(imovel.ALIQUOTA);
    }

    if (imovel.ALIQUOTA2) {
      setAliquota2(imovel.ALIQUOTA2);
    }
  }, [
    imovel.VALOR_PREFEITURA_TERRENO,
    imovel.VALOR_PREFEITURA_BENFEITORIAS,
    imovel.ALIQUOTA,
    imovel.ALIQUOTA2,
  ]);

  return (
    <>
      <Container
        onClick={() => setOpenModalAvaliacao(true)}
        interactive={editavel}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Table
          size="small"
          style={{
            border: "1px solid rgba(224, 224, 224, 1)",
            background: theme.colors.light,
            borderRadius: "0.5rem",
            width: "50%",
          }}
        >
          <TableHead>
            <TableRow>
              <Th></Th>
              <Th>Contribuinte</Th>
              <Th>Fazenda</Th>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <Th>Terreno</Th>
              <TableCell>
                {(imovel.VALOR_CARTORIO_TERRENO
                  ? imovel.VALOR_CARTORIO_TERRENO
                  : 0
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
              <TableCell>
                {(imovel.VALOR_PREFEITURA_TERRENO
                  ? imovel.VALOR_PREFEITURA_TERRENO
                  : 0
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <Th>Benfeitorias</Th>
              <TableCell>
                {(imovel.VALOR_CARTORIO_BENFEITORIAS
                  ? imovel.VALOR_CARTORIO_BENFEITORIAS
                  : 0
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
              <TableCell>
                {(imovel.VALOR_PREFEITURA_BENFEITORIAS
                  ? imovel.VALOR_PREFEITURA_BENFEITORIAS
                  : 0
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <Th>Total</Th>
              <TableCell>
                {(
                  (imovel.VALOR_CARTORIO_BENFEITORIAS
                    ? imovel.VALOR_CARTORIO_BENFEITORIAS
                    : 0) +
                  (imovel.VALOR_CARTORIO_TERRENO
                    ? imovel.VALOR_CARTORIO_TERRENO
                    : 0)
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
              <TableCell>
                {(
                  (imovel.VALOR_PREFEITURA_BENFEITORIAS
                    ? imovel.VALOR_PREFEITURA_BENFEITORIAS
                    : 0) +
                  (imovel.VALOR_PREFEITURA_TERRENO
                    ? imovel.VALOR_PREFEITURA_TERRENO
                    : 0)
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <Th>Valor Pago à vista</Th>
              <TableCell>
                {(imovel.ENTRADA ? imovel.ENTRADA : 0).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Section
          style={{
            border: "1px solid rgba(224, 224, 224, 1)",
            background: theme.colors.light,
            borderRadius: "0.5rem",
            width: "45%",
          }}
        >
          {!imovel.TIPO_TRIBUTACAO ? (
            <>
              <HelperDiv>
                <Label>
                  Total
                  <Value>
                    {(restanteAvaliacao + entrada + totalDeclaradoMenosEntrada).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </Value>
                </Label>
                <Label>
                  Alíquota
                  <Value>
                    <span
                      onClick={() => window.alert("Alíquota sobre entrada")}
                    >
                      {aliquota
                        .toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                        .replace("R$", "")}
                      %
                    </span>{" "}
                    |{" "}
                    <span
                      onClick={() =>
                        window.alert("Alíquota sobre financiamento")
                      }
                    >
                      {aliquota2
                        .toLocaleString("pt-br", {
                          style: "currency",
                          currency: "BRL",
                        })
                        .replace("R$", "")}
                      %
                    </span>
                  </Value>
                </Label>
                <Label>
                  Valor do Imposto
                  <Value>
                    {(
                      (totalDeclaradoMenosEntrada) * (aliquota / 100) +
                      (restanteAvaliacao + entrada) * (aliquota2 / 100)
                    ).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })}

                  </Value>
                </Label>
              </HelperDiv>
              <HelperDiv>
                <Label>
                  Avaliado
                  <Value>
                    {imovel.AVALIADO
                      ? new Date(imovel.AVALIADO).toLocaleDateString("pt-BR")
                      : "--/--/----"}
                  </Value>
                </Label>
                <Label>
                  Vencimento
                  <Value>
                    {imovel.VENC
                      ? new Date(imovel.VENC).toLocaleDateString("pt-BR")
                      : "--/--/----"}
                  </Value>
                </Label>
              </HelperDiv>
            </>
          ) : (
            <>
              <HelperDiv>
                <Label>
                  Avaliado
                  <Value>
                    {imovel.AVALIADO
                      ? new Date(imovel.AVALIADO).toLocaleDateString("pt-BR")
                      : "--/--/----"}
                  </Value>
                </Label>
              </HelperDiv>
              <HelperDivNaoTributado>
                <TitleConclusao>{imovel.CLASSE_NAO_TRIBUTADO}</TitleConclusao>
                <Typography id="obs_nao_tributado">
                  {imovel.OBS_NAO_TRIBUTADO}
                </Typography>
              </HelperDivNaoTributado>
            </>
          )}
        </Section>
      </Container>
      {editavel && (
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <br />
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={() => {
              setOpenModalAvaliacao(true);
            }}
          >
            {" "}
            Editar Avaliação
          </Button>
        </div>
      )}

      {editavel ? (
        <ModalAvaliacao
          open={openModalAvaliacao}
          onClose={() => { setOpenModalAvaliacao(false); window.location.reload(); }}
          imovel={imovel}
          handleSetImovel={handleSetImovel}
        />
      ) : null}
    </>
  );
}
